
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      modalData: {},
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      this.$gsap.set('.science__card', {
        alpha: 0,
      })

      // science slider anim
      this.$gsap
        .timeline({
          scrollTrigger: {
            trigger: '#science-slider',
            // markers: true,
            start: 'top bottom',
          },
        })
        .to('.science__card', {
          alpha: 1,
          duration: 0.3,
          stagger: 0.1,
          ease: 'back.in',
          // clearProps: 'all',
        })
    },
    setModalData(data) {
      this.modalData = data
      this.showModal = true
    },
    closeModal() {
      this.modalData = {}
      this.showModal = false
    },
    setModalDataFromNav(id) {
      this.modalData = this.blok.science_cards.find((x) => x._uid === id)
    },
  },
}
